import { Signin } from "./Signin/Signin";

export const AuthenticationView = () => {
  return <Signin />;
};
